let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dKxx9")).then(() => parcelRequire('hSqdi'));